import { useCallback } from 'react';
import { useLogAnalyticsEvent } from '../../../../../hooks/useLogAnalyticsEvent';
import type { IScreensLogging } from '../../../../../api/types/IScreenLogging';
import type { PromotionShortBannerEntity } from '../types';

export const useLogClickShortBanner = (logging: IScreensLogging) => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    (entity: PromotionShortBannerEntity) => {
      logAnalyticsEvent({
        name: 'CLICK_SHORT_BANNER',
        analytics: {
          ...logging?.analytics,
          ...entity.logging?.analytics,
        },
        ably_only_log: {
          ...logging?.ably_only_log,
          ...entity.logging?.ably_only_log,
        },
      });
    },
    [logAnalyticsEvent, logging],
  );
};
